export default __webpack_public_path__ + "static/media/mSubscriptionPlan.8bb28f89.png";